/* eslint-disable react/prop-types */
import { useEffect } from 'react';
import { useStore } from '@thd-nucleus/experience-context';
import { useParams } from '@thd-olt-component-react/router';
import { useDigitalDataStore, useProductInfoStore } from '../../store';

export const TrackPageLoad = () => {
  const store = useStore();
  const { itemId: partnerProductId } = useParams();
  const { trackCustomProductPipLoadedEvent } = useDigitalDataStore((state) => state);
  const { productInfo } = useProductInfoStore((state) => state);

  useEffect(() => {

    if (productInfo) {
      const pageName = `${productInfo?.brand.toLowerCase()} ${productInfo?.displayName.toLowerCase()}`;
      const omnitureInfo = {
        primaryCategory: 'tools',
        subCategory1: 'tools>tool storage',
        subCategory2: `tools>tool storage>modular tool storage systems>${pageName} configurator`
      };
      const brand = productInfo?.brand || 'Milwaukee';
      const productName = productInfo?.productName || 'Packout Portable Storage';
      const pageType = `tool:${pageName}:configurator`;
      trackCustomProductPipLoadedEvent(
        partnerProductId,
        productName,
        brand,
        false, // logEventsToConsole,
        omnitureInfo,
        false, // sendPaymentEstimatorImpressionToAnalytics
        store,
        pageType
      );
    }
  }, [productInfo]);
  return null;
};
